import Showcase from '@/components/marketing/features/showcase/Showcase'
import AudiencePage from '@/components/marketing/technology/AudiencePage'
import type { TechnologyAudienceProps } from '@/types/technology'

/* /technology/labels — the labels & label groups audience page.
 *
 * Its one visual is the REAL dashboard (the SSR-safe Showcase frame, label
 * variant, the catalogue), because a label buyer's question is "what will my
 * team work in", and the dashboard answers it better than a mock. Rule 2: none
 * of this page's copy says "white label".
 */
export default function Labels(props: TechnologyAudienceProps) {
  return (
    <AudiencePage
      {...props}
      media={<Showcase screen="catalog" variant="label" label="A label's catalogue in the wavbee dashboard" />}
    />
  )
}
